import { TradeInRequest, TradeInResponse, VendorSubsidyResponse } from '@app/sales/models/trade-in-product.model';
import { ImeiValidation, StorageCapacityAlternative } from '@app/sales/modules/mobilephone/models/trade-in-api.model';
import { TradeInImeiErrorType } from '@app/sales/modules/mobilephone/models/trade-in-enums';

export class SetSelectedTradeInStepIndexAction {
  public static readonly type = '[TradeIn] Set selected trade in step index';
  constructor(public index: number) {}
}

export class AddInteractedTradeInStepAction {
  public static readonly type = '[TradeIn] Add interacted trade in step';
  constructor(public index: number) {}
}

export class SetIsValidatingImeiAction {
  public static readonly type = '[TradeIn] Set is validating IMEI';
  constructor(public isValidatingImei: boolean) {}
}

export class ValidateImeiSuccessAction {
  public static readonly type = '[TradeIn] Validate IMEI success';
  constructor(
    public imeiValidation: ImeiValidation,
    public imei: string
  ) {}
}

export class ValidateImeiFailureAction {
  public static readonly type = '[TradeIn] Validate IMEI failure';
  constructor(public error: TradeInImeiErrorType) {}
}

export class SetSelectedStorageCapacityAction {
  public static readonly type = '[TradeIn] Set selected storage capacity';
  constructor(public storageCapacity: StorageCapacityAlternative) {}
}

export class GetGradingQuestionsAction {
  public static readonly type = '[TradeIn] Get grading questions';
}

export class TradeInProductResetAction {
  static readonly type = '[TradeIn] Reset trade in product state';
}

export class QuoteResetAction {
  static readonly type = '[TradeIn] Reset quote';
}

export class SetIsCalculatingTradeInValueAction {
  static readonly type = '[TradeIn] Set is calculating trade in value';
  constructor(public isCalculatingTradeInValue: boolean) {}
}

export class SetIsCalculatingVendorSubsidyAction {
  static readonly type = '[TradeIn] Set is calculating vendor subsidy';
  constructor(public isCalculatingVendorSubsidy: boolean) {}
}

export class CreateTradeInVoucherAction {
  static readonly type = '[TradeIn] Create trade in voucher';
  constructor(public tradeInRequest: TradeInRequest) {}
}

export class CreateTradeInVoucherSuccessAction {
  static readonly type = '[TradeIn] Create trade in voucher success';
  constructor(public tradeInVoucher: TradeInResponse) {}
}

export class CreateTradeInVoucherFailureAction {
  static readonly type = '[TradeIn] Create trade in voucher failure';
}

export class AcceptTradeInQuoteAction {
  static readonly type = '[TradeIn] Accept trade in quote';
  constructor(public tradeInId: number) {}
}

export class CreateOrUpdateTradeInVendorSubsidyVoucher {
  static readonly type = '[TradeIn] Create or update trade in vendor subsidy voucher';
  constructor(public isTriggeredFromMobile = false) {}
}

export class NotifyUserOfVendorSubsidyAction {
  static readonly type = '[TradeIn] Notify user of vendor subsidy';
  constructor(
    public existingSubsidy: VendorSubsidyResponse,
    public newSubsidy: VendorSubsidyResponse
  ) {}
}

export class AcceptTradeInVoucherAction {
  static readonly type = '[TradeIn] Accept voucher';
  constructor() {}
}

export class SelectTradeInProductAction {
  static readonly type = '[TradeIn] Select trade in product';
  constructor(public isSelected: boolean) {}
}
